import React from "react";

function FamilyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
    >
      <g clip-path="url(#clip0_1388_2203)">
        <path
          d="M4.51562 0C5.17867 0 5.81455 0.263392 6.28339 0.732233C6.75223 1.20107 7.01562 1.83696 7.01562 2.5C7.01562 3.16304 6.75223 3.79893 6.28339 4.26777C5.81455 4.73661 5.17867 5 4.51562 5C3.85258 5 3.2167 4.73661 2.74786 4.26777C2.27902 3.79893 2.01562 3.16304 2.01562 2.5C2.01562 1.83696 2.27902 1.20107 2.74786 0.732233C3.2167 0.263392 3.85258 0 4.51562 0ZM16.0156 0C16.6787 0 17.3146 0.263392 17.7834 0.732233C18.2522 1.20107 18.5156 1.83696 18.5156 2.5C18.5156 3.16304 18.2522 3.79893 17.7834 4.26777C17.3146 4.73661 16.6787 5 16.0156 5C15.3526 5 14.7167 4.73661 14.2479 4.26777C13.779 3.79893 13.5156 3.16304 13.5156 2.5C13.5156 1.83696 13.779 1.20107 14.2479 0.732233C14.7167 0.263392 15.3526 0 16.0156 0ZM0.015625 9.33438C0.015625 7.49375 1.50937 6 3.35 6H4.68437C5.18125 6 5.65312 6.10938 6.07812 6.30312C6.0375 6.52812 6.01875 6.7625 6.01875 7C6.01875 8.19375 6.54375 9.26562 7.37187 10C7.36562 10 7.35938 10 7.35 10H0.68125C0.315625 10 0.015625 9.7 0.015625 9.33438ZM12.6812 10C12.675 10 12.6687 10 12.6594 10C13.4906 9.26562 14.0125 8.19375 14.0125 7C14.0125 6.7625 13.9906 6.53125 13.9531 6.30312C14.3781 6.10625 14.85 6 15.3469 6H16.6812C18.5219 6 20.0156 7.49375 20.0156 9.33438C20.0156 9.70312 19.7156 10 19.35 10H12.6812ZM7.01562 7C7.01562 6.20435 7.3317 5.44129 7.8943 4.87868C8.45691 4.31607 9.21998 4 10.0156 4C10.8113 4 11.5743 4.31607 12.1369 4.87868C12.6996 5.44129 13.0156 6.20435 13.0156 7C13.0156 7.79565 12.6996 8.55871 12.1369 9.12132C11.5743 9.68393 10.8113 10 10.0156 10C9.21998 10 8.45691 9.68393 7.8943 9.12132C7.3317 8.55871 7.01562 7.79565 7.01562 7ZM4.01562 15.1656C4.01562 12.8656 5.88125 11 8.18125 11H11.85C14.15 11 16.0156 12.8656 16.0156 15.1656C16.0156 15.625 15.6437 16 15.1812 16H4.85C4.39062 16 4.01562 15.6281 4.01562 15.1656Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1388_2203">
          <path d="M0.015625 0H20.0156V16H0.015625V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default FamilyIcon;
